import { useMemo } from 'react';
import { useAnnouncementBannerSettingsV4Resource } from '@jira/admin-pages__system-announcement-banner-resources/src/useAnnouncementBannerSettingsV4Resource.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { NAME, HEIGHT } from './name.constants.tsx';

export const useBannerAnnouncement = (): {
	isEnabled: boolean;
	name: 'ANNOUNCEMENT';
	height: number;
} => {
	const { data } = useAnnouncementBannerSettingsV4Resource();

	const isAnonymous = useIsAnonymous();

	return useMemo(
		() => ({
			isEnabled:
				Boolean(data?.isEnabled) &&
				!data?.isDismissed &&
				((data?.visibility === 'private' && !isAnonymous) || data?.visibility === 'public'),
			name: NAME,
			height: HEIGHT,
		}),
		[data?.isDismissed, data?.isEnabled, data?.visibility, isAnonymous],
	);
};
